import cssUtil from 'gw-portals-util-js/CssUtil';
import template from 'text!./gw-dropdown-directive.html';
import styles from './gwDropdownDirective-hashed.scss';

export default [function () {
    return {
        restrict: 'E',
        scope: {
            onOpen: '&',
            onClose: '&'
        },
        transclude: {
            'target': 'gwDropdownTarget',
            'content': 'gwDropdownContent'
        },
        template: cssUtil.hashTemplate(template, styles),
        controller: ['$scope', function ($scope) {
            // Passes down handlers to underlying dropdown directive
            $scope._dropdownOnOpen = $scope.onOpen;
            $scope._dropdownOnClose = $scope.onClose;
        }]
    };
}];


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/platform/widgets/dropdown/directives/gw-dropdown/gwDropdownDirective.js
// module id = 1113
// module chunks = 0